import React, { useContext, useState } from 'react';
import {
	Paper,
	Box,
	Tabs,
	Tab,
	Divider,
	Typography,
	Container,
	Stack,
	Button
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faCalendarCheck,
	faChevronCircleLeft,
	faClipboardUser,
	faCreditCard,
	faHandHoldingDollar,
	faPeopleArrows,
	faHouseChimneyMedical,
	faUserXmark
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { DataContext } from '../../../../context/DataContext';
import { useNavigate, useParams } from 'react-router-dom';
import { getRuta } from '../../../../helpers/Helpers';
import EmployeeDetails from './EmployeeDetails';
import Vacaciones from './Vacaciones';
import Adelantos from './Adelantos';
import Prestamos from './Prestamos';
import Subsidios from './Subsidios';
import Permisos from './Permisos';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`
	};
}

export const EmployeDetailsContainer = () => {
	let ruta = getRuta();
	let navigate = useNavigate();
	const { id } = useParams();
	const [value, setValue] = useState(0);
	const [employeeName, setEmployeeName] = useState('');

	const [basico, setBasico] = useState(0);
	const [isActive, setIsActive] = useState(true);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20,
						textAlign: 'center'
					}}
				>
					<Stack
						direction={{ xs: 'column', sm: 'row' }}
						alignItems="center"
						spacing={1}
						justifyContent={'space-between'}
					>
						<Stack
							direction={{ xs: 'column', sm: 'row' }}
							alignItems="center"
							spacing={1}
						>
							<Button
								onClick={() => {
									navigate(`${ruta}/employees`);
								}}
								style={{
									color: '#2979ff',
									borderColor: '#2979ff'
								}}
								variant="outlined"
							>
								<FontAwesomeIcon
									style={{ marginRight: 10, fontSize: 20 }}
									icon={faChevronCircleLeft}
								/>
								Regresar
							</Button>

							<Stack direction={'row'} spacing={1}>
								<Typography
									color={'#00a152'}
									variant="h6"
									fontWeight={'bold'}
									className="d-none d-sm-block"
								>
									Cliente:
								</Typography>
								<Typography variant="h6" fontWeight={'bold'}>
									{employeeName}
								</Typography>
							</Stack>
						</Stack>

						<Stack direction={'row'} spacing={1}>
							<Typography
								color={'#ffc400'}
								fontSize={12}
								fontWeight={'bold'}
								className="d-none d-sm-block"
							>
								Salario Basico:
							</Typography>
							<Typography fontSize={12} fontWeight={'bold'}>
								{new Intl.NumberFormat('es-NI', {
									style: 'currency',
									currency: 'NIO'
								}).format(basico)}
							</Typography>
						</Stack>
					</Stack>

					<Divider style={{ marginTop: 10 }} />

					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="icon label tabs example"
						centered
					>
						<Tab
							icon={
								<FontAwesomeIcon icon={faClipboardUser} style={{ fontSize: 20 }} />
							}
							label="Empleado"
							{...a11yProps(0)}
							style={{ fontSize: 12 }}
						/>

						<Tab
							icon={
								<FontAwesomeIcon icon={faCalendarCheck} style={{ fontSize: 20 }} />
							}
							label="Vacaciones"
							{...a11yProps(1)}
							style={{ fontSize: 12 }}
						/>
						<Tab
							disabled={!isActive}
							icon={
								<FontAwesomeIcon
									icon={faHouseChimneyMedical}
									style={{ fontSize: 20 }}
								/>
							}
							label="Subsidios"
							{...a11yProps(2)}
							style={{ fontSize: 12 }}
						/>
						<Tab
							disabled={!isActive}
							icon={<FontAwesomeIcon icon={faUserXmark} style={{ fontSize: 20 }} />}
							label="Constancia"
							{...a11yProps(3)}
							style={{ fontSize: 12 }}
						/>

						<Tab
							icon={
								<FontAwesomeIcon icon={faCalendarCheck} style={{ fontSize: 20 }} />
							}
							label="Adelanto"
							{...a11yProps(4)}
							style={{ fontSize: 12 }}
						/>

						<Tab
							icon={
								<FontAwesomeIcon
									icon={faHandHoldingDollar}
									style={{ fontSize: 20 }}
								/>
							}
							label="Prestamo"
							{...a11yProps(5)}
							style={{ fontSize: 12 }}
						/>
					</Tabs>

					<Divider style={{ marginTop: 10 }} />

					<TabPanel value={value} index={0}>
						<EmployeeDetails
							id={id}
							setEmployeeName={setEmployeeName}
							setBasico={setBasico}
							isActive={isActive}
							setIsActive={setIsActive}
						/>
					</TabPanel>
					<TabPanel value={value} index={1}>
						<Vacaciones id={id} />
					</TabPanel>
					<TabPanel value={value} index={2}>
						<Subsidios id={id} />
					</TabPanel>
					<TabPanel value={value} index={3}>
						<Permisos id={id} />
					</TabPanel>
					<TabPanel value={value} index={4}>
						<Adelantos id={id} />
					</TabPanel>
					<TabPanel value={value} index={5}>
						<Prestamos id={id} />
					</TabPanel>
				</Paper>
			</Container>
		</div>
	);
};
